import {
  APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_BEGIN,
  APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_SUCCESS,
  APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_FAILURE,
  APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addLocalizationKeyValue(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}localization/addKeyandValue`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddLocalizationKeyValueError() {
  return {
    type: APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_BEGIN:
      return {
        ...state,
        addLocalizationKeyValuePending: true,
        addLocalizationKeyValueError: null,
      };

    case APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_SUCCESS:
      return {
        ...state,
        addLocalizationKeyValuePending: false,
        addLocalizationKeyValueError: null,
        localization: action.data,
      };

    case APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_FAILURE:
      return {
        ...state,
        addLocalizationKeyValuePending: false,
        addLocalizationKeyValueError: action.data.error,
      };

    case APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_DISMISS_ERROR:
      return {
        ...state,
        addLocalizationKeyValueError: null,
      };

    default:
      return state;
  }
}
